export default "__VITE_ASSET__DYXeigHV__"